import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { MainFacade } from '../../../main.facade';
import { IFileInfo } from '../../../models/file-info';
import { FormBuilder, Validators } from '@angular/forms';
import { RequestFactory } from '../../../models/request.factory';
import { RetinalLayerModels } from '../../../models/request';
import { SubmissionStateService } from '../../../../services/submission-state.service';
import { ProcessComponentBase } from '../process.component.base';

@Component({
  selector: 'retinal-layer',
  templateUrl: './retinal-layer.component.html',
  styleUrls: ['./retinal-layer.component.scss'],
})
export class RetinalLayerComponent extends ProcessComponentBase implements OnInit {

  public inputImages: IFileInfo[] = [];

  public modelTypes: any[] = [ 'resunet_a_2d', 'vnet_2d' ];
  public resunetModels: any[] = [
    RetinalLayerModels.RESUNET_A_2D_RL_40X,
    RetinalLayerModels.RESUNET_A_2D_RL_20X,
    RetinalLayerModels.RESUNET_A_2D_RL_40X_OLD
  ];
  public vnetModels: any[] = [
    RetinalLayerModels.VNET_2D_RL_40X
  ];

  selectedModelType = this.modelTypes[0];
  selectedModel = this.resunetModels[0];


  constructor(mainFacade: MainFacade,
              private fb: FormBuilder		,
						  submissionState: SubmissionStateService) {
								
		super('Retinal Layer Segmentation', submissionState, mainFacade);
	}

  ngOnInit(): void {
    this.configForm();
    this.mainFacade.getSelectedNode$().subscribe({
      next: (node) => {
        if (node == undefined || node.data == undefined) {
          this.bucket = undefined;
        } else {
          this.setImagesInput(node);
        }
      },
      error: (err) => {
        console.error(`Error with node selection: ${err}`);
      },
    });
    this.mainFacade.getValidationMessage$().subscribe({
      next: (message) => {
        this.validationMessage = message;
      }
    });
  }

  setImagesInput(node: TreeNode<IFileInfo>) {
    this.inputImages = [];
    // if folder
    if (!node.leaf) {
      node.children?.forEach(child => {
        if (child.data && this.isImageExtension(child.data.name)) {
          this.inputImages.push(child.data);
        }
      });
    } else {
      // if file
      if (node.data && this.isImageExtension(node.data.name)) {
        this.inputImages.push(node.data);
      }
    }
    this.bucket = node.data?.project.bucket;
    this.path = node.parent?.data?.relPath;
  }

  isImageExtension(name: string) {
    const extension = name.toLowerCase().split('.').pop();
    return extension === 'tif' || extension === 'tiff' || extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'ndpi';
  }
  configForm() {
    this.form = this.fb.group({
      model: [this.modelTypes[0], Validators.required],
      resunetModel: [this.resunetModels[0], Validators.required],
      vnetModel: [this.vnetModels[0], Validators.required],
      step: [512, Validators.required],
      patchSize: [512, Validators.required],
      outputFolder: [null, Validators.required],
      editOutputFolder: [false]
    });
    this.persistForm();
  }

  selectModelType(modelType: string) {
    this.selectedModelType = modelType;
  }

  selectModel(event: any) {
    this.selectedModel = event.value;
    // set value of 256 for step in form if model is 20x
    if (this.selectedModel === RetinalLayerModels.RESUNET_A_2D_RL_20X) {
      this.form.get('step')?.setValue(256);
      this.form.get('patchSize')?.setValue(256);
    } else {
      this.form.get('step')?.setValue(512);
      this.form.get('patchSize')?.setValue(512);
    }
  }

  onSubmit() {
    super.submit(this.buildRequest());
  }

  onCreateRule() {
    super.createRule(this.buildRequest());
  }

  private buildRequest() {
    const formValue = this.form.value;
    const bucket = this.bucket;
    const parentPath = this.path;
    const modelPath: string = formValue.model === this.modelTypes[0]
      ? formValue.resunetModel : formValue.vnetModel;
    return RequestFactory.getRetinalLayerRequest(
      bucket, parentPath, this.inputImages, ('/app/models/' + modelPath), formValue.model,
      formValue.step, formValue.patchSize,
      formValue.outputFolder);
  }

}